(() => {
  'use strict';

  const PARAM_NAME = 'promo';

  // Read ?promo= from URL
  const code = new URLSearchParams(window.location.search).get(PARAM_NAME);
  if (!code) return;

  // Parse campaign data from inline JSON
  const dataEl = document.getElementById('promo-campaigns');
  if (!dataEl) return;

  let campaigns;
  try {
    campaigns = JSON.parse(dataEl.textContent);
  } catch (e) {
    return;
  }

  // Find matching campaign
  const campaign = campaigns.find(c => c.code === code);
  if (!campaign) return;

  // Tag links to campaign products so ?promo= carries to new tabs
  const productList = campaign.products || [];
  productList.forEach(handle => {
    document.querySelectorAll(`a[href*="${handle}"]`).forEach(link => {
      const url = new URL(link.href, window.location.origin);
      if (url.searchParams.has(PARAM_NAME)) return;
      url.searchParams.set(PARAM_NAME, code);
      link.href = url.href;
    });
  });

  // Replace content following promo target markers
  // HTML is pre-sanitized by Shopify's metafield_tag filter
  document.querySelectorAll('[data-promo-target]').forEach(target => {
    const field = target.getAttribute('data-promo-target');
    const sibling = target.nextElementSibling;

    if (field && campaign[field] && sibling) {
      sibling.innerHTML = campaign[field];
    }
  });

  // PDP: inject promo text if current product is in the campaign's product list
  if (!campaign.pdp_text || !productList.length) return;

  const handleMatch = window.location.pathname.match(/\/products\/([^/?#]+)/);
  if (!handleMatch || !productList.includes(handleMatch[1])) return;

  const mobileAnchor = document.querySelector('.product__top.product__primary');
  const desktopAnchor = document.querySelector('.product__block--product-header');

  if (mobileAnchor) {
    const mobileEl = document.createElement('div');
    mobileEl.className = 'promo-campaign-pdp promo-campaign-pdp--mobile';
    mobileEl.innerHTML = campaign.pdp_text;
    mobileAnchor.parentNode.insertBefore(mobileEl, mobileAnchor);
  }

  if (desktopAnchor) {
    const desktopEl = document.createElement('div');
    desktopEl.className = 'promo-campaign-pdp promo-campaign-pdp--desktop';
    desktopEl.innerHTML = campaign.pdp_text;
    desktopAnchor.parentNode.insertBefore(desktopEl, desktopAnchor.nextSibling);
  }
})();
